import { render, staticRenderFns } from "./KlaimManifestDirektur.vue?vue&type=template&id=fc6dc130&"
import script from "./KlaimManifestDirektur.vue?vue&type=script&lang=js&"
export * from "./KlaimManifestDirektur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports